export default __webpack_public_path__ + "static/media/lager_822_info_3.a5902654.png";